// ==================== AUTH LAYOUT ====================
// Used for: Login, Register, Forgot Password, Reset Password, Verify Email

import { Outlet, Link } from 'react-router-dom';
import { Logo } from '../components/ui/Logo';
import { ROUTES } from '../constants';

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex bg-(--color-midnight-navy)">
      {/* Left Side - Branding & Visual */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-linear-to-br from-(--color-dark-navy) via-(--color-midnight-navy) to-(--color-navy-light)" />
        
        {/* Decorative Elements */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-(--color-signal-orange)/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-(--color-signal-orange)/5 rounded-full blur-3xl" />
        
        {/* Waveform Pattern */}
        <div className="absolute bottom-0 left-0 right-0 h-32 opacity-20">
          <svg className="w-full h-full" viewBox="0 0 1200 100" preserveAspectRatio="none">
            <path
              d="M0,50 Q150,0 300,50 T600,50 T900,50 T1200,50 L1200,100 L0,100 Z"
              fill="url(#waveGradient)"
            />
            <defs>
              <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="var(--color-signal-orange)" />
                <stop offset="100%" stopColor="var(--color-warm-amber)" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center px-12 xl:px-16">
          <Link to={ROUTES.HOME}>
            <Logo size="xl" className="mb-8" />
          </Link>
          
          <h1 className="text-4xl xl:text-5xl font-heading font-bold text-white leading-tight mb-4">
            Amplify Your
            <span className="text-gradient block">Conversations</span>
          </h1>
          
          <p className="text-lg text-(--color-soft-gray) max-w-md leading-relaxed">
            Transform your WhatsApp Business communications into measurable growth with our powerful automation platform.
          </p>
          
          {/* Feature Highlights */}
          <div className="mt-12 space-y-4">
            {[
              'Smart messaging automation',
              'Campaign management & analytics',
              'Contact segmentation & targeting',
              'Template library & scheduling',
            ].map((feature, index) => (
              <div key={index} className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-(--color-signal-orange)" />
                <span className="text-(--color-soft-gray)">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Side - Auth Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="lg:hidden mb-8 text-center">
            <Link to={ROUTES.HOME}>
              <Logo size="lg" className="justify-center" />
            </Link>
          </div>
          
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export { AuthLayout };

